import React, { FC, useState } from 'react';

import {
    FormPasswordText,
    FormPasswordIcon,
    FormPasswordFieldStyles,
} from './styled';

import { Icon } from 'components';

const FormPasswordField: FC<React.InputHTMLAttributes<HTMLInputElement>> = (
    args,
) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <FormPasswordFieldStyles>
            <FormPasswordText
                {...args}
                type={showPassword ? 'text' : 'password'}
            />
            <FormPasswordIcon>
                <Icon
                    name={showPassword ? 'eye_blocked' : 'eye'}
                    size={24}
                    onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                        e.preventDefault();
                        setShowPassword(!showPassword);
                    }}
                />
            </FormPasswordIcon>
        </FormPasswordFieldStyles>
    );
};

export default FormPasswordField;
